// extracted by mini-css-extract-plugin
export default {"success":"feeRowStyle_success__1kq66","warning":"feeRowStyle_warning__xLHEt","danger":"feeRowStyle_danger__kSv8H"};